export const safeJSONParse = (str: string): Record<string, unknown> => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return {};
  }
};
